import React from "react";

/**
 * Injects brand kit (colors + fonts) into the page via a scoped <style> tag.
 * Wrap the storefront root with data-storefront="true" then this style applies.
 * Use to make TenantSettings → brand_kit fully reflect on the public storefront.
 */
export default function BrandStyle({ brand = {}, scope = '[data-storefront="true"]' }) {
  const primary = brand.primary_color || "#0F1B14";
  const secondary = brand.secondary_color || "#C25934";
  const fontHeading = brand.font_heading || "Cabinet Grotesk";
  const fontBody = brand.font_body || "Inter";
  // Pre-load the chosen Google Fonts if not already in index.html
  const fontFamilies = [fontHeading, fontBody].filter(Boolean).map((f) => f.replace(/ /g, "+")).join("&family=");
  const gfontUrl = `https://fonts.googleapis.com/css2?family=${fontFamilies}:wght@400;500;600;700&display=swap`;

  const css = `
    ${scope} {
      --brand-primary: ${primary};
      --brand-secondary: ${secondary};
      --font-heading: "${fontHeading}", serif;
      --font-body: "${fontBody}", system-ui, sans-serif;
    }
    ${scope}, ${scope} body, ${scope} input, ${scope} select, ${scope} textarea, ${scope} button {
      font-family: var(--font-body);
    }
    ${scope} h1, ${scope} h2, ${scope} h3, ${scope} h4, ${scope} .font-heading, ${scope} .editorial-h1, ${scope} .editorial-h2 {
      font-family: var(--font-heading);
    }
    ${scope} .bg-brand, ${scope} .brand-bg { background-color: ${primary} !important; }
    ${scope} .bg-brand-hover, ${scope} .hover\\:bg-brand-hover:hover { background-color: ${primary}cc !important; }
    ${scope} .text-brand { color: ${primary} !important; }
    ${scope} .border-brand { border-color: ${primary} !important; }
    ${scope} .text-accent, ${scope} .brand-accent { color: ${secondary} !important; }
    ${scope} .bg-accent-brand { background-color: ${secondary} !important; }
  `;

  return (
    <>
      <link rel="stylesheet" href={gfontUrl} />
      <style dangerouslySetInnerHTML={{ __html: css }} />
    </>
  );
}
